module.exports = __webpack_public_path__ + "static/media/detectDataImage_en.73b1197d.png";